export default __webpack_public_path__ + "static/media/btn-drift-off@2x.e3d5d0e6.png";